"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Icon_1 = __importDefault(require("../Icon"));
var styles_1 = __importDefault(require("./styles"));
var File = function (_a) {
    var name = _a.name, isHidden = _a.isHidden, className = _a.className, type = _a.type, style = _a.style, onClick = _a.onClick, isDisabled = _a.isDisabled;
    if (isHidden)
        return null;
    var classNames = (className || '') + " " + (isDisabled ? 'disabled' : '');
    return (react_1.default.createElement(styles_1.default, { className: classNames, style: style, onClick: !isDisabled && onClick },
        react_1.default.createElement(Icon_1.default, { className: "icon", icon: type }),
        react_1.default.createElement("span", { className: "name" }, name)));
};
exports.default = File;
//# sourceMappingURL=index.js.map